import { IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useIntl } from "react-intl";

// Widget'larda ortak arama kutusu. `count` verilirse sağda sonuç sayısı
// rozeti gösterilir (aramaya göre güncellenir).
const SearchBox = ({ value, onChange, placeholderId, count, className = "" }) => {
	const intl = useIntl();
	const placeholder = intl.formatMessage({ id: placeholderId });

	return (
		<div className={`widget-search ${className}`}>
			<SearchIcon className="widget-search__icon" />
			<InputBase
				className="widget-search__input"
				placeholder={placeholder}
				inputProps={{ "aria-label": placeholder }}
				onChange={(e) => onChange(e.target.value)}
				value={value}
			/>
			{count != null && (
				<span className="widget-search__count" aria-live="polite">
					{count}
				</span>
			)}
			{value && (
				<IconButton
					size="small"
					aria-label={intl.formatMessage({ id: "close" })}
					onClick={() => onChange("")}
				>
					<HighlightOffIcon fontSize="small" />
				</IconButton>
			)}
		</div>
	);
};

export default SearchBox;
